"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.icon = exports.button = void 0;

var _util = require("../../../util");

const button = ({
  theme,
  cssProps: {
    isOpen,
    disabled,
    variant
  }
}) => {
  const variantTheme = theme.dropdownButton[variant];
  return {
    background: (0, _util.color)(theme, variantTheme.bg),
    borderRadius: variantTheme.borderRadius,
    height: variantTheme.height,
    cursor: disabled ? 'not-allowed' : 'pointer',
    transition: 'color 0.2s ease, background 0.2s ease, box-shadow 0.2s ease',
    '&:not(:disabled):active': {
      background: (0, _util.color)(theme, variantTheme.activeBg),
      '& > span': {
        color: (0, _util.color)(theme, variantTheme.activeFontColor)
      },
      '& > svg path': {
        stroke: (0, _util.color)(theme, variantTheme.activeFontColor)
      }
    },
    '&:disabled': {
      background: (0, _util.color)(theme, variantTheme.disabledBg)
    },
    boxShadow: isOpen && !disabled ? (0, _util.boxShadow)(theme, [0, 0, 0, 1, variantTheme.activeBorderColor, true]) : 'none'
  };
};

exports.button = button;

const icon = ({
  theme
}) => ({
  pointerEvents: 'none',
  margin: (0, _util.spacing)(theme, [0, 0, 0, 4])
});

exports.icon = icon;
//# sourceMappingURL=DropdownButton.style.js.map